export default class AppResponse {
  success;
  messsage;
  data;

  constructor(success, message, data) {
    this.success = success;
    this.message = message;
    this.data = data;
  }
}
